import { Outlet } from 'react-router-dom';
import { useAppLocation } from 'services/navigation/use-location';
import { useProfileRole } from 'common/use-profile-role';
import { PageProtectorBase } from './Base/PageProtectorBase';

export const AdminPageProtector = () => {
  const location = useAppLocation();
  const { isAdmin } = useProfileRole();

  return (
    <PageProtectorBase to={'/page-not-found'} condition={isAdmin} state={{ from: location }}>
      <Outlet />
    </PageProtectorBase>
  );
};
